export enum UserRole {
  RetailerAdmin = 'RETAILER_ADMIN',
}
